import { Box, Text } from '@razorpay/blade/components';
import React from 'react';

interface InfoBoxProps {
  label: string;
  children?: React.ReactNode;
}

export const SummaryViewItem = ({ label, children }: InfoBoxProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="spacing.2">
      <Text size="medium" color="interactive.text.gray.muted">
        {label}
      </Text>
      {children}
    </Box>
  );
};

export const SummaryView = ({ children }: { children?: React.ReactNode }) => {
  return (
    <Box display="flex" gap="spacing.8">
      {children}
    </Box>
  );
};
